// export const API_BASE_URL = 'http://192.168.1.7:8080/api/v1/';
// export const API_BASE_URL = 'http://192.168.1.11:8080/api/v1';
// export const API_BASE_URL = 'https://api-chakaravarthycatering.webdadsprojects.com/api/v1';
export const API_BASE_URL = process.env.REACT_APP_API_URL;
